import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Login.css";

const Doctors = ({ doctor }) => {
  if (!doctor) return null;

  const {
    name,
    specialization,
    qualification,
    experience,
    rating,
    description,
    photoPreview,
  } = doctor;

  return (
    <div className="col-lg-4 col-md-6 mb-5">
      <div className="aesthetic-card">
        <div className="image-wrapper">
          <img
            src={photoPreview}
            alt={name}
            className="doctor-img"
            onError={(e) => {
              e.target.src = 'https://via.placeholder.com/400x400/6366f1/ffffff?text=Doctor';
            }}
            loading="lazy"
          />
          <div className="floating-specialty shadow-sm">{specialization}</div>
          <div className="glass-rating">
            <i className="bi bi-stars me-1 text-warning"></i> {rating}
          </div>
        </div>

        <div className="content-area">
          <div className="header-text">
            <h4 className="doctor-name">Dr. {name}</h4>
            <p className="qualification-text">{qualification}</p>
          </div>

          <div className="info-pills">
            <div className="pill-item">
              <span className="pill-icon">
                <i className="bi bi-clock-history"></i>
              </span>
              <span className="pill-text">{experience}y+ Exp</span>
            </div>

            <div className="pill-item">
              <span className="pill-icon">
                <i className="bi bi-patch-check-fill text-primary"></i>
              </span>
              <span className="pill-text text-primary">Verified</span>
            </div>
          </div>

          <p className="aesthetic-description">{description}</p>
          <div className="card-accent-line"></div>
        </div>
      </div>
    </div>
  );
};

const UserDoctorsPanel = () => {
  const doctorsData = [
    {
      id: 1,
      name: "Raj Kumar",
      specialization: "Cardiology",
      qualification: "MD, DM Cardiology",
      experience: 12,
      rating: 4.8,
      description:
        "Expert in cardiac care with specialized knowledge in interventional cardiology and heart failure management.",
      photoPreview: "/images/doctors/doctor6.jpg",
    },
    {
      id: 2,
      name: "Priya Sharma",
      specialization: "Dermatology",
      qualification: "MBBS, MD Dermatology",
      experience: 8,
      rating: 4.7,
      description:
        "Specialist in skin care, cosmetic treatments, and advanced dermatological procedures.",
      photoPreview: "/images/doctors/doctor3.jpg",
    },
    {
      id: 3,
      name: "Vikram Singh",
      specialization: "Orthopedics",
      qualification: "MS Orthopedics, Fellowship Spine",
      experience: 15,
      rating: 4.9,
      description:
        "Experienced in joint replacement, sports medicine, and minimally invasive spine surgery.",
      photoPreview: "/images/doctors/doctor2.jpg",
    },
    {
      id: 4,
      name: "Dr. Anjali Patel",
      specialization: "Pediatrics",
      qualification: "MBBS, MD Pediatrics",
      experience: 10,
      rating: 4.6,
      description:
        "Compassionate pediatrician providing comprehensive child healthcare and development support.",
      photoPreview: "/images/doctors/doctor4.jpg",
    },
    {
      id: 5,
      name: "Dr. Arun Mishra",
      specialization: "Neurology",
      qualification: "DM Neurology, MD Medicine",
      experience: 14,
      rating: 4.8,
      description:
        "Specialist in neurological disorders with expertise in migraine, epilepsy, and stroke management.",
      photoPreview: "/images/doctors/doctor5.jpg",
    },
    {
      id: 6,
      name: "Dr. Neha Gupta",
      specialization: "Gynecology",
      qualification: "MBBS, MD Obstetrics & Gynecology",
      experience: 11,
      rating: 4.7,
      description:
        "Expert in women's health with specialized knowledge in pregnancy care and fertility treatments.",
      photoPreview: "/images/doctors/doctor6.jpg",
    },
  ];

  return (
    <div className="user-panel-container">
      <div className="container mb-5">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <span className="text-uppercase fw-bold tracking-widest small-heading">
              Our Expertise
            </span>
            <h2 className="display-5 fw-bold text-dark mt-2 mb-3">
              Meet Our Specialized Doctors
            </h2>
            <div className="heading-divider mx-auto mb-4"></div>
            <p className="text-muted fs-5">
              Connect with India's top-rated medical professionals. Expert care,
              advanced technology, and compassionate treatment—all in one place.
            </p>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          {doctorsData.map((doctor) => (
            <Doctors key={doctor.id} doctor={doctor} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default UserDoctorsPanel;
